// features/employee/fund/components/EmployeeFundEmptyState.jsx
import { PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";
import { useTranslation } from "react-i18next";
import styles from "../styles/EmployeeFund.module.css";

const { Title, Text } = Typography;

const EmployeeFundEmptyState = ({ onAdd = () => { } }) => {
    const { t } = useTranslation();

    return (
        <div className={styles.emptyState}>
            <Flex vertical align="center" gap={4}>
                {/* <div style={{ fontSize: 56, marginBottom: 8 }}>👛</div> */}
                <Title level={5} style={{ margin: 0 }}>
                    {t("employeeFund.label.emptyTitle") || "พนักงานยังไม่ได้เข้าร่วมกองทุน"}
                </Title>
                <Text type="secondary" style={{ textAlign: "center" }}>
                    {t("employeeFund.label.emptyDescriptionLine1") || "พนักงานยังไม่มีข้อมูลการเข้าร่วมกองทุน"}
                    <br />
                    {t("employeeFund.label.emptyDescriptionLine2") ||
                        "คุณสามารถเพิ่มกองทุนที่พนักงานมีสิทธิ์เข้าร่วมได้ที่นี่"}
                </Text>
                <Button type="default" icon={<PlusOutlined />} onClick={onAdd} style={{ marginTop: 16 }}>
                    {t("employeeFund.label.addFund") || "เพิ่มกองทุน"}
                </Button>
            </Flex>
        </div>
    );
};

export default EmployeeFundEmptyState;
